import type { GeneralFieldOptionPopupProps } from "../../../common/fields/types/generalFieldOptionPopup.types";
import GeneralFieldOptionPopup from "./GeneralFieldOptionPopup";

const ColumnFieldOptionPopup = (props: GeneralFieldOptionPopupProps) => {
  return (
    <GeneralFieldOptionPopup {...props} supportedDateGroupings={props.field.meta.options?.supportedColumnGrouping} />
  );
};

export default ColumnFieldOptionPopup;
